import { request } from "../api";
import { LogData } from "@admin/domain/logs/dto/LogItem";

export const getLogs = async (query: string): Promise<LogData> => {
    return await request({
        url: `/admin/logs`,
        query,
    });
};
